import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BusService {

  constructor(private http:HttpClient) { }
  cityList(type:any){
    return this.http.get( environment.API_URL+"/api/product/bus/cities/"+type,{ observe : "body",responseType : "json"})  
  }
  
  search(request:any){
    return this.http.post( environment.API_URL+"/api/product/bus/bus-search" ,request,{ observe : "body",responseType : "json"})  
  }
  searchSeats(request:any){
    return this.http.post( environment.API_URL+"/api/product/bus/bus-details" ,request,{ observe : "body",responseType : "json"})  
  }


}
